export const createNumberInputKeydownHandler = (
  min = 1,
  max = 100,
  maxDigits = 3
) => {
  return (event: KeyboardEvent) => {
    const input = event.target as HTMLInputElement;
    const currentValue = input.value;
    const key = event.key;

    if (
      [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
      ].includes(key)
    ) {
      return;
    }

    if (!/^\d$/.test(key)) {
      event.preventDefault();
      return;
    }

    const selectionStart = input.selectionStart || 0;
    const selectionEnd = input.selectionEnd || 0;
    const newValue =
      currentValue.slice(0, selectionStart) +
      key +
      currentValue.slice(selectionEnd);
    const numValue = Number(newValue);

    if (numValue < min || numValue > max || newValue.length > maxDigits) {
      event.preventDefault();
    }
  };
};

export const handleScaleKeydown = createNumberInputKeydownHandler(1, 100, 3);
